import React from 'react';
import NumberFormat, { NumberFormatProps } from 'react-number-format';

interface CustomNumberInputProps extends NumberFormatProps {
  inputRef: any;
  onChange: any;
}

const CustomNumberInput: React.FC<CustomNumberInputProps> = ({ inputRef, onChange, ...other }) => (
  <NumberFormat
    {...other}
    allowNegative={false}
    decimalScale={2}
    getInputRef={inputRef}
    onValueChange={(values: any) => {
      onChange({
        target: {
          name: other.name,
          value: values.value,
        },
      });
    }}
    prefix="$"
    thousandSeparator
  />
);

export default CustomNumberInput;
